import React from "react"

export const LoadingContext = React.createContext<{
  saveLoading: boolean
  sendRequestLoading: boolean
}>({
  saveLoading: false,
  sendRequestLoading: false
})
